// src/utils/Notify.ts
import { notification } from 'antd';

class Notify {
  static info(message?: string, duration = 3) {
    notification.info({
      message: message || 'Info',
      placement: 'topRight',
      duration: duration,
      style: {
        backgroundColor: '#fff', // Установите фоновый цвет, если нужно
        border: '1px solid #1890ff', // Установите цвет рамки, если нужно
        padding: '16px', // Установите отступы, если нужно
      },
      icon: <i className="anticon anticon-info-circle" />,
    });
  }

  static success(message?: string, duration = 3) {
    notification.success({
      message: message || 'Success',
      placement: 'topRight',
      duration: duration,
      style: {
        backgroundColor: '#fff',
        border: '1px solid #52c41a',
        padding: '16px',
      },
      icon: <i className="anticon anticon-check-circle" />,
    });
  }

  static error(message?: string, duration = 3, description = '') {
    notification.error({
      message: message || 'Error',
      description,
      placement: 'topRight',
      duration: duration,
      style: {
        backgroundColor: '#fff',
        border: '1px solid #f5222d',
        padding: '16px',
      },
      icon: <i className="anticon anticon-close-circle" />,
    });
  }

  static warning(message?: string, duration = 3) {
    notification.warning({
      message: message || 'Warning',
      placement: 'topRight',
      duration: duration,
      style: {
        backgroundColor: '#fff',
        border: '1px solid #faad14',
        padding: '16px',
      },
      icon: <i className="anticon anticon-exclamation-circle" />,
    });
  }
}

export { Notify };
